// @flow
const decode = s => {
    let decoded = s;
    if (s !== null && s !== undefined) {
        decoded = decoded.replace(/&#039;/g, "’");
        decoded = decoded.replace(/`/g, "’");
        decoded = decoded.replace(/#115;/g, "s");
        decoded = decoded.replace(/&amp;/g, "&");
    }
    return decoded;
};

export { decode };



// WEBPACK FOOTER //
// ./src/utils/string.js